import React, { Component } from 'react';
import './Fcm.css';
import NotificationSystem from 'react-notification-system';
import Modal from 'react-responsive-modal';
import { getMessaging, getToken, onMessage } from "firebase/messaging";


class Fcm extends Component {
  constructor(props) {
    super(props);
    this.state = { open: false, next: true, mensaje: '' };
    this._notificationSystem = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    this.initMessaging();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.firebaseApp && this.props.firebaseApp) {
      this.initMessaging();
    }
  }

  initMessaging = async () => {
  const { firebaseApp, newToken } = this.props;
  if (!firebaseApp) return;

  const messaging = getMessaging(firebaseApp);

  try {
    // Verificar estado del permiso
    if (Notification.permission === "denied") {
      console.warn("El usuario bloqueó las notificaciones desde el navegador.");
      this.setState({ open: true, next: false }); // abrimos modal pero solo para mostrar la ayuda
      return;
    }

    if (Notification.permission === "default") {
      // No pedimos token aún → mostramos primer modal
      this.setState({ open: true, next: true });
      return;
    }

    // Solo si ya está "granted" intentamos obtener token
    const currentToken = await getToken(messaging, { 
      vapidKey: 'BLjauej_v09ToQrlPtsO9YezSupetmWeajHXcfAepnfBce6f2sjgQCpQpAZHjzz6ibb4PFABj1zLAIETFOnSlVE',
      serviceWorkerRegistration: await navigator.serviceWorker.register('/firebase-messaging-sw.js')
    });

    if (currentToken) {
      console.log("siToken FCM:", currentToken);
      newToken(currentToken);
      this.setState({ open: false });
      this.initListener(messaging);
    }
  } catch (err) {
    console.error("Error al obtener token:", err);
  }
  

  onMessage(messaging, (payload) => {
    if (payload.notification) {
      this._addNotification(payload.notification);
    }
  });
};

  _addNotification = (notification) => {
    if (!this._notificationSystem) return;
    this._notificationSystem.addNotification({
      children: (
        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <img className="icono" src={notification.icon} alt="genesis"/>
          </div>
          <div className="col-lg-8 col-md-8 col-sm-8">
              <p className="font-weight-bold">{notification.title}</p>
              <p>{notification.body}</p>
          </div>
        </div>
      ),
      level: 'info',
      position:'br',
      dismissible:true,
      autoDismiss:0
    });
  }

  onCloseModal = async () => {
    this.setState({ open: false });
  }

  handleAceptar = () => {
    // Cerrar primer modal y mostrar segundo
    this.setState({ next: false });
  };

  handleFinalAceptar = async () => {
  const { firebaseApp, newToken } = this.props;
  if (!firebaseApp) return;

  const messaging = getMessaging(firebaseApp);

  try {
    // Ahora sí pedimos permiso al navegador
    const permission = await Notification.requestPermission();

    if (permission === "granted") {
      const currentToken = await getToken(messaging, { 
        vapidKey: 'BLjauej_v09ToQrlPtsO9YezSupetmWeajHXcfAepnfBce6f2sjgQCpQpAZHjzz6ibb4PFABj1zLAIETFOnSlVE',
        serviceWorkerRegistration: await navigator.serviceWorker.register('/firebase-messaging-sw.js')
      });

      if (currentToken) {
        console.log("Token FCM:", currentToken);
        newToken(currentToken);
        this.initListener(messaging);
      }
    }

    // Cerrar modal siempre al final
    this.setState({ open: false });

  } catch (err) {
    console.error("Error al aceptar notificaciones:", err);
    this.setState({ open: false });
  }
};


initListener = (messaging) => {
  onMessage(messaging, (payload) => {
    console.log("Mensaje recibido en foreground:", payload);
    if (payload.notification) {
      this._addNotification(payload.notification);
    }
  });
}



  render() {
    const { open, next } = this.state;
    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
        <Modal open={open} onClose={this.onCloseModal} little>
          {next ? (
            <div className="modal-container">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-8 offset-lg-4 offset-md-3 offset-sm-2 text-center">
                  <div className="panel-body">
                    <img src={require("../../../../assets/img/alertas/notificacion1fcm.png")} alt="Permitir notificaciones"/>
                  </div>
                </div>
              </div>
              <div className="text-center txt">
                <span className="reset-caption">El sistema necesita enviarte notificaciones para mantenerte actualizado.</span><br/>
                <span className="reset-caption">¿Deseas recibir estas notificaciones?</span>
              </div>
              <div className="text-center botones">
                <button
                  onClick={this.onCloseModal}
                  className="btn btn-action mt-lg later"
                  type="button"
                >
                  Más tarde
                </button>
                <button
                  onClick={this.handleAceptar}
                  className="btn btn-default mt-lg"
                  type="button"
                >
                  Aceptar
                </button>
              </div>
            </div>
          ) : (
            <div className="modal-container">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-8 offset-lg-3 offset-md-3 offset-sm-2 text-center">
                  <div className="panel-body">
                    <img className="alert-permitir" src={require("../../../../assets/img/alert-permitir.png")} alt="Permitir en navegador"/>
                  </div>
                </div>
              </div>
              <div className="text-center txt">
                <span className="reset-caption">Te aparecerá un mensaje como el de la imagen</span><br/>
                <span className="reset-caption">Es necesario que selecciones "Permitir"</span>
              </div>
              <div className="text-center">
                <button
                  onClick={this.handleFinalAceptar}
                  className="btn btn-default mt-lg botones"
                  type="button"
                >
                  Aceptar
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    );
  }
}

export default Fcm;
